export const DOWNLOAD_TAX_DOCUMENT_KEY = 'downloadTaxDocument';
